import {
  Cloud,
  CloudLightning,
  CloudRain,
  CloudSun,
  Sun,
  type LucideIcon,
} from "lucide-react";
import type { WeatherCondition } from "./agendaWeatherTypes";

export function weatherConditionIcon(
  condition: WeatherCondition
): LucideIcon {
  switch (condition) {
    case "clear":
      return Sun;
    case "partly_cloudy":
      return CloudSun;
    case "cloudy":
      return Cloud;
    case "rain":
    case "heavy_rain":
      return CloudRain;
    case "storm":
      return CloudLightning;
    default:
      return Cloud;
  }
}

export type RainPillTier = "none" | "low" | "medium" | "high" | "severe";

export function rainPillTier(rainChance: number): RainPillTier {
  if (rainChance < 30) {
    return "none";
  }
  if (rainChance < 45) {
    return "low";
  }
  if (rainChance < 70) {
    return "medium";
  }
  if (rainChance < 80) {
    return "high";
  }
  return "severe";
}

export function rainPillClassName(tier: RainPillTier): string {
  switch (tier) {
    case "low":
      return "bg-sky-100 text-sky-800";
    case "medium":
      return "bg-sky-200 text-sky-900";
    case "high":
      return "bg-sky-500 text-white";
    case "severe":
      return "bg-sky-700 text-white";
    default:
      return "";
  }
}

export const WEATHER_RAIN_PILL_THRESHOLD = 30;
export const WEATHER_ALERT_RAIN_THRESHOLD = 70;
